import { getGeneratedFlashcardText } from "@/shared/flashcard-content";
import type { WhiteboardSpec } from "./spec";

/** A save candidate must come from exercise language, never its display title. */
export function whiteboardFlashcardText(spec: WhiteboardSpec): string | null {
  let text: string | undefined;
  if (spec.kind === "gap_fill") text = spec.sentence.replace(/_{3,}/, spec.answer);
  else if (spec.kind === "word_tiles") text = spec.answer;
  else if (spec.kind === "quick_choice")
    text = spec.answerIndex === undefined ? undefined : spec.options[spec.answerIndex];
  else if (spec.kind === "reading_story") text = spec.story.split(/(?<=[.!?。！？])\s*/u)[0];
  else if (spec.kind === "composed") {
    for (const block of spec.blocks) {
      switch (block.type) {
        case "pronunciation_focus":
          text = block.phrase;
          break;
        case "sentence_repair":
          text = block.corrected;
          break;
        case "slot_sentence": {
          text = block.sentence;
          for (const answer of block.answers) text = text.replace(/_{3,}/, answer);
          break;
        }
        case "translation_choice":
          text = block.answer || block.options.find((option) => option.quality === "natural")?.text;
          break;
        case "contrast_pair": {
          const pair = block.pairs[0];
          text = pair?.answer === "right" ? pair.right : pair?.answer ? pair.left : undefined;
          break;
        }
        case "phrase_bank_roleplay":
          text = (block.phrases.find((phrase) => phrase.recommended) || block.phrases[0])?.text;
          break;
        case "listening_discrimination":
          text = block.answer;
          break;
        case "morphology_grid":
          text = block.rows[0]?.cells[0]?.answer;
          break;
        case "transformation_frame":
          text = block.items[0]?.answer;
          break;
        case "pair_match":
          text = block.leftItems[0]?.text;
          break;
        case "ordering":
          text = block.items.join(" ");
          break;
        case "tap_group":
          text = block.correct?.[0];
          break;
        default:
          break;
      }
      if (text) break;
    }
  }
  try {
    return getGeneratedFlashcardText({ targetText: text });
  } catch {
    return null;
  }
}
